import React, { useEffect, useRef, useState } from "react";

const Counter = ({ startValue, endValue, speed = 400, decimals = 0, className }) => {
  const [count, setCount] = useState(startValue);
  const ref = useRef(null);
  const hasStarted = useRef(false);

  useEffect(() => {
    const animateCount = () => {
      const totalSteps = speed;
      const increment = (endValue - startValue) / totalSteps;
      let current = startValue;
      let step = 0;

      const timer = setInterval(() => {
        step++;
        current += increment;

        if (step >= totalSteps) {
          clearInterval(timer);
          setCount(endValue);
        } else {
          setCount(parseFloat(current.toFixed(decimals)));
        }
      }, 10);

      return () => clearInterval(timer);
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted.current) {
          hasStarted.current = true;
          animateCount();
        }
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [startValue, endValue, speed, decimals]);

  return (
    <span ref={ref} className={className}>
      {typeof count === 'number' ? count.toFixed(decimals) : count}
    </span>
  );
};

export default Counter;